import { EntryType } from 'components/registry/types/api';
import { homePageBreadcrumbs } from 'utils/breadcrumbs';
import { FileType } from 'types/types';
import { ActiveSubstancesOption } from 'api/dict/params';
import { IS_NEW_CODE } from '../../types';
import { PharmPermissionDTO, ProducerType } from '../types/types';

export const VIEW_TITLE = 'Просмотр';
export const EDIT_TITLE = 'Редактирование';

export const getBreadcrumbs = (link: string, id: string, isEdit: boolean, entryType: EntryType) => {
  const breadcrumbsArray = [
    homePageBreadcrumbs,
    {
      text: 'Разрешения на ввод в гражданский оборот',
    },
    {
      link,
      text:
        entryType === EntryType.requests
          ? 'Список заявок'
          : 'Реестр разрешений на ввод в гражданский оборот',
    },
    {
      link: `/registry/pharmPermissions/registry/${id}`,
      text: 'Просмотр',
    },
  ];
  if (isEdit) {
    breadcrumbsArray.push({
      text: 'Редактирование',
      link: '',
    });
  }
  return breadcrumbsArray;
};

const getDefaultProducerList = (producerList?: ProducerType[]) => {
  if (!producerList || producerList.length === 0) {
    return [];
  }
  return producerList.map((el) => {
    const { locationList, ...rest } = el;
    return {
      tempData: {
        ...rest,
        value: rest.address ? rest.address.id : undefined,
        name: rest.address ? rest.address.businessEntity?.name : rest.name,
        locationList: [],
      },
      ...rest,
      locationList,
    };
  });
};

const getDefaultActiveSubstance = (
  activeSubstanceName?: string,
  activeSubstance?: ActiveSubstancesOption
) => {
  if (!activeSubstanceName && !activeSubstance) {
    return undefined;
  }
  return (
    activeSubstance || {
      name: activeSubstanceName!,
      code: IS_NEW_CODE,
    }
  );
};

export const normalizeDefaultValues = async (
  data: PharmPermissionDTO<FileType>
): Promise<PharmPermissionDTO<File[]>> => {
  const {
    qualityDocumentInformation,
    activeSubstanceName,
    activeSubstance,
    confirmDocumentInformation,
    testReportInformation,
    rejectInformation,
  } = data;
  const formattedProducersList = getDefaultProducerList(data.producerList);
  return {
    ...data,
    activeSubstanceName: undefined,
    activeSubstance: getDefaultActiveSubstance(activeSubstanceName, activeSubstance),
    registryProduct: data?.registryProduct || {
      name: data.registryProductName,
    },
    producerList: formattedProducersList,
    qualityDocumentInformation: {
      ...qualityDocumentInformation,
      qualityDocFile: undefined,
    },
    confirmDocumentInformation: {
      ...confirmDocumentInformation,
      confirmDocFile: undefined,
    },
    testReportInformation: testReportInformation
      ? {
          ...testReportInformation,
          testReportFile: undefined,
        }
      : undefined,
    rejectInformation: rejectInformation
      ? {
          ...rejectInformation,
          rejectFile: undefined,
        }
      : undefined,
    uploadedQuality: qualityDocumentInformation.qualityDocFile
      ? [qualityDocumentInformation.qualityDocFile]
      : undefined,
    uploadedConfirm: confirmDocumentInformation.confirmDocFile
      ? [confirmDocumentInformation.confirmDocFile]
      : undefined,
    uploadedTestReport: testReportInformation?.testReportFile
      ? [testReportInformation?.testReportFile]
      : undefined,
    uploadedReject: rejectInformation?.rejectFile ? [rejectInformation?.rejectFile] : undefined,
  };
};
